import { resolvePath, useLocation } from 'react-router';

import type { NavAction } from './NavAction';
import { resolveNavAction } from './resolveNavAction';

export function useGetNavActionUrl() {
	const location = useLocation();

	return (navAction: NavAction) => {
		const resolvedPath = resolvePath(resolveNavAction(location, navAction).to);
		return resolvedPath.pathname + resolvedPath.search + resolvedPath.hash;
	};
}
